import { Breadcrumbs, Grid } from "@mui/material";
import GlobalCard from "../../../UI/card/GlobalCard";
import "./RolesAndPermission.scss";
import Breadcrumb from "../../../UI/breadcrumb/breadcrumb";
import AddEmplopeeIcon from "../../../assets/setting/rolsAndpermissions/Group.svg";
import empicon from "../../../assets/setting/rolsAndpermissions/empicon.svg";
import { useState } from "react";
import AddPermission from "./permissiongroup/AddPermission";
import MoreVertIcon from '@mui/icons-material/MoreVert';
// let penalCards: any = [];

const RolesAndPermission = () => {
  const [showPermissionCVard, setShowPermissionCard] = useState(false);
  const tempArray = [
    { name: "Employee Directory |" },
    { name: " Home ", onClickNavigateTo: "/" },
    { name: " > Team" },
  ];
  
  const addCard = [
    {
      title: "Admins",
      description:"Admins are super users,they have access to everything and can manage all Data.",
      numberOfEmploye: 6

    },
    {
      title: "Managers",
      description:"Set the level of access managers have to their direct and indirect reports’ information.",
      numberOfEmploye: 5
    },
    {
      title: "Employees",
      description:"Control what employees can see on their colleagues’ profiles and throughout Bob. ",
      numberOfEmploye: 26
    },


  ];
  const [cardsData,setCardsData] = useState(addCard); // penal cards list state

  // const colorsList = ["#5558AB", "#2CD591", "#FE4E88", "#1890FF"];
  // let [penalCards, setPenalCard] = useState<any>([]); // penal cards list state
  // const [inc, setInc] = useState(0); // for increment color array index

  // let handlePanel = () => {
  //   // handleInc()
  //   (inc>=colorsList.length-1 ) ? setInc(0): setInc(inc + 1);
  //   setCardsData([...cardsData, {bg:colorsList[inc],title:"title",description:"Admins are super users,they have access to everything and can manage all Data.",numberOfEmploye:10}]);
  // };

  // console.log(penalCards);
  // console.log(inc);
  return (
    <div className="roles_And_Permission_wrapper">
      <Breadcrumb breadCrumbData={tempArray} />
      {!showPermissionCVard && (
        <GlobalCard classNames="Extar_styling">
          <Grid
            container
            rowSpacing={4}
            columnSpacing={4}
            className="Grid_main_container"
          >
            {/* add new role section */}
            <Grid item xs={12} sm={6} md={4} lg={3} className="Grid_Colum">
              <div
                onClick={() => setShowPermissionCard(true)}
                className="Rols_permission_Card br-10 d-flex flex-column"
              >
                <div className="content_wraper">
                  <h3 className="h3 heading_custom_style fw-600">Add New</h3>
                </div>
                <div className="icon_wraper d-flex align-center justify-end ">
                  <img src={AddEmplopeeIcon} alt="Icon" />
                </div>
              </div>
            </Grid>
            {cardsData.map((cardData:any, index:number) =>(
              <Grid key={index} item xs={12} sm={6} md={4} lg={3} className="Grid_Colum">
              <div className=" Rols_permission_Card cursor_none br-10 d-flex flex-column"   >
             
                <div className="content_wraper">
                 <div className="flex-center-between ">
                 <h3 className="h3 heading_custom_style fw-600">{cardData.title}</h3>
                  {index > 2 && <p className=""><MoreVertIcon/></p>}
                 </div>
                  <p className="role_Card_text">
                    {cardData.description}
                  </p>
                </div>
                <div className="icon_wraper d-flex align-center  ">
                  <img src={empicon} alt="Icon" />
                  <p className="Employee_length">
                    {cardData.numberOfEmploye} <span>Employes</span>
                  </p>
                </div>
              </div>
            </Grid>

            ))}
            {/* {penalCards.map((penal: any, index: any) => (
              <Grid key={index} item xs={12} sm={6} md={4} lg={3}>
                <Box
                  sx={{ background: penal.bg }}
                  className=" Rols_permission_Card br-10 d-flex flex-column"
                >
                  <div className="content_wraper">
                    <h3 className="h3 heading_custom_style fw-600">
                      {penal.title}
                    </h3>
                    <p className="role_Card_text">{penal.text}</p>
                  </div>
                  <div className="icon_wraper d-flex align-center  ">
                    <img src={empicon} alt="Icon" />
                    <p className="Employee_length">
                      {penal.employees} <span>Employes</span>
                    </p>
                  </div>
                </Box>
              </Grid>
            ))} */}
          </Grid>
        </GlobalCard>
      )}
      {showPermissionCVard && <AddPermission close={()=>setShowPermissionCard(false)} cardsData={cardsData} setCardsData={setCardsData}/>}
    </div>
  );
};

export default RolesAndPermission;
